<script lang="ts" setup>
  import { ExternalRoute } from "@/constants/externalRoute"
  import Link from "@/components/ui/link/Link.vue"
</script>
<template>
  <h4>
    We're sorry to hear about your technical issues. Our team is here to help.
  </h4>
  <p>
    Whether your issue was with your meter, supply, online account, or something
    else, we want to try and help you resolve it.
  </p>
  <p>
    <Link class="link text-primary-600" :to="ExternalRoute.contactUs">
      Get in touch with our customer support team here
    </Link>
    , or on
    <Link class="link text-primary-600" to="mailto:help@so.energy"
      >help@so.energy</Link
    >
    or
    <Link class="link text-primary-600" to="tel:0330 111 5050"
      >0330 111 5050</Link
    >
    (Mon-Fri 9am-5pm) and let us know the problem.
  </p>
</template>
